import { win } from "./pd-window";

const availableLangs = ["de", "fr"];

export const setupSiteLanguage = () => {
  const currentPath = window.location.pathname;
  win.pd.lang = getLangFromPath(currentPath);
};

export const getSiteLanguage = () => {
  return win.pd.lang || "en";
};

export const getUrlLanguage = (url) => {
  const urlObj = new URL(url);
  return getLangFromPath(urlObj.pathname);
};

const getLangFromPath = (path) => {
  const pathParts = path.split("/");

  if (pathParts.length > 1 && availableLangs.includes(pathParts[1])) {
    return pathParts[1];
  }
  return "en";
};
